// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"0ce08c68","513":"066be817","703":"36a7d379"}[chunkId] + ".chunk.js";
};